<template>
  <v-container grid-list-lg>
    <v-layout row>
      <v-flex xs12 class="text-center display-1 mt-10">Services</v-flex>
    </v-layout>
    <v-layout row wrap class="mb-5">
      <v-flex xs12 sm12 md4>
        <v-card to="/services" height="650px">
          <v-img src="@/assets/images/plans/paper-and-tea.jpg" height="500px">
            <v-container fill-height fluid>
              <v-layout fill-height>
                <v-flex xs12 align-end flexbox>
                  <span class="headline white--text">ACCOUNTING</span>
                </v-flex>
              </v-layout>
            </v-container>
          </v-img>

          <v-card-title primary-title>
            <div>
              <h3 class="headline mb-0">Accounting</h3>
              <div class="subtitle-1">
                Bookkeeping for all sales, preparation of HST and more...
              </div>
            </div>
          </v-card-title>
        </v-card>
      </v-flex>

      <v-flex xs12 sm12 md4>
        <v-card to="/services" height="650px">
          <v-img src="@/assets/images/plans/paper-and-glass.jpg" height="500px">
            <v-container fill-height fluid>
              <v-layout fill-height>
                <v-flex xs12 align-end flexbox>
                  <span class="headline white--text">PAYROLL</span>
                </v-flex>
              </v-layout>
            </v-container>
          </v-img>
          <v-card-title primary-title>
            <div>
              <h3 class="headline mb-0">Payroll</h3>
              <div class="subtitle-1">
                Payroll transactions and preparation...
              </div>
            </div>
          </v-card-title>
        </v-card>
      </v-flex>

      <v-flex xs12 sm12 md4>
        <v-card to="/services" height="650px">
          <v-img
            src="@/assets/images/plans/paper-and-calculator.jpg"
            height="500px"
          >
            <v-container fill-height fluid>
              <v-layout fill-height>
                <v-flex xs12 align-end flexbox>
                  <span class="headline white--text">PERSONAL TAXATION</span>
                </v-flex>
              </v-layout>
            </v-container>
          </v-img>
          <v-card-title primary-title>
            <div>
              <h3 class="headline mb-0">
                Personal and Corporate Tax Preparation
              </h3>
              <div class="subtitle-1">
                Preparation of personal tax...
              </div>
            </div>
          </v-card-title>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: 'HomeServices'
}
</script>

<style scoped>
.headline,
.subtitle-1 {
  word-break: keep-all;
}
</style>
